import { setIsHeaderVisibleAction } from "@store/app/appReducer";
import { useAppDispatch } from "@store/store";
import { useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

/**
 * Utility component to hide the widget when the user enters Street View.
 */
const StreetView = () => {
  const map = useMap();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!map) {
      return;
    }

    const panorama = map.getStreetView();

    const handleVisibleChanged = () => {
      const mapDiv = map.getDiv();

      if (panorama.getVisible()) {
        mapDiv.parentElement!.style.zIndex = "9999999";
        dispatch(setIsHeaderVisibleAction(false));
      } else {
        mapDiv.parentElement!.style.zIndex = "0";
        dispatch(setIsHeaderVisibleAction(true));
      }
    };

    panorama.addListener("visible_changed", handleVisibleChanged);
  }, [dispatch, map]);

  return <></>;
};

export { StreetView };
